import React from 'react';

class IrRepeaterIcon extends React.Component {
  render() {
    return (
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_241_635)">
          <g filter="url(#filter0_d_241_635)">
            <path
              d="M60.348 57.8781H19.652C11.008 57.8781 4 50.8701 4 42.2261H76C76 50.8701 68.992 57.8781 60.348 57.8781Z"
              fill="#E0DDDA"
            />
            <path
              d="M57.4283 23.4801C50.9663 22.3321 45.0623 22.1601 40.0003 22.1221C34.9383 22.1601 29.0343 22.3341 22.5723 23.4801C2.2003 27.0981 4.0443 40.6601 4.0443 40.6601H75.9563C75.9563 40.6601 77.8003 27.0981 57.4283 23.4801Z"
              fill="#F7F4F1"
            />
            <path
              d="M76.132 41.44C76.452 41.368 76.704 41.106 76.748 40.77C76.768 40.62 77.218 37.074 75.034 33.048C71.434 26.416 63.548 23.758 57.568 22.694C51.164 21.556 45.344 21.362 39.994 21.322C34.656 21.362 28.836 21.556 22.432 22.694C11.594 24.618 6.95196 29.386 4.96596 33.048C2.77996 37.074 3.23196 40.622 3.25196 40.77C3.29796 41.106 3.54996 41.37 3.86996 41.44C3.49196 41.504 3.20196 41.83 3.20196 42.226C3.20196 51.298 10.582 58.678 19.654 58.678H60.35C69.422 58.678 76.802 51.298 76.802 42.226C76.802 42.014 76.718 41.81 76.568 41.66C76.45 41.542 76.298 41.466 76.134 41.438L76.132 41.44ZM6.37196 33.81C8.97996 29.004 14.632 25.704 22.712 24.268C28.998 23.152 34.74 22.96 39.994 22.922C45.26 22.962 51.002 23.152 57.288 24.268C65.32 25.696 70.956 28.966 73.584 33.728C75.014 36.32 75.204 38.722 75.198 39.862H4.79996C4.79196 38.74 4.97396 36.386 6.37196 33.81ZM60.348 57.08H19.652C11.73 57.08 5.23796 50.846 4.82196 43.028H75.178C74.76 50.848 68.268 57.08 60.348 57.08Z"
              fill="#84827E"
            />
            <path
              d="M40.0003 51.4001C38.7043 51.4001 37.6523 50.3481 37.6523 49.0521C37.6523 47.7561 38.7043 46.7041 40.0003 46.7041C41.2963 46.7041 42.3483 47.7561 42.3483 49.0521C42.3483 50.3481 41.2963 51.4001 40.0003 51.4001Z"
              fill="url(#paint0_linear_241_635)"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_d_241_635"
            x="1.8002"
            y="19.922"
            width="79.6016"
            height="43.356"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="1.6" dy="1.6" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_241_635"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_241_635"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_241_635"
            x1="38.3128"
            y1="47.1241"
            x2="41.5005"
            y2="50.7806"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <clipPath id="clip0_241_635">
            <rect width="80" height="80" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
}

export default IrRepeaterIcon;
